import { Configuration, LogLevel } from '@azure/msal-browser';
import AppLogger, { SeverityLevel } from '@shared/logging/appLogger';

export const formatLogoutUri = (auctionsHomePageUrl: string) => {
    if (!auctionsHomePageUrl) {
        return '';
    }

    let homepageUrl = auctionsHomePageUrl;

    if (!homepageUrl.endsWith('/')) {
        homepageUrl += '/';
    }

    return `${homepageUrl}login.aspx/logoutallapps`;
};

const msalConfig: Configuration = {
    auth: {
        clientId: process.env.OAUTH_CLIENT_ID || '',
        authority: process.env.OAUTH_AUTHORITY,
        knownAuthorities: [process.env.OAUTH_ISSUER || ''],
        redirectUri: '/auth',
        postLogoutRedirectUri: formatLogoutUri(process.env.AUCTIONS_HOMEPAGE_URL || ''),
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'localStorage',
    },
    system: {
        tokenRenewalOffsetSeconds: process.env.ENV_NAME?.toLowerCase() === 'prod' ? 300 : 60, // QA tokens only good for 300 seconds, causes token thrashing
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                //console.log(message); // uncomment for local debugging
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        AppLogger.logException({
                            error: new Error(message),
                        });
                        return;
                    case LogLevel.Warning:
                        AppLogger.logTrace({
                            message,
                            severityLevel: SeverityLevel.Warning,
                        });
                        return;
                }
            },
        },
        windowHashTimeout: 60000,
        iframeHashTimeout: 60000,
        loadFrameTimeout: 60000,
    },
};

export default msalConfig;
export const scopes = [process.env.OAUTH_METADATA_SCOPE];
